var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTime = function SvgTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.444 3.685A10 10 0 0 1 12 2a10.01 10.01 0 0 1 10 10A10 10 0 1 1 6.444 3.685m1.39 14.551A7.5 7.5 0 0 0 12 19.5a7.51 7.51 0 0 0 7.5-7.5 7.5 7.5 0 1 0-11.667 6.236m5.416-7.486h2.5a1.25 1.25 0 0 1 0 2.5H12A1.25 1.25 0 0 1 10.75 12V8.25a1.25 1.25 0 0 1 2.5 0z",
    clipRule: "evenodd"
  })));
};
export default SvgTime;